import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth-store';
import { useSessionQuery } from './useSessionQuery';

/**
 * GET `/admin/account` on app load — keeps Zustand auth in sync with the cookie session.
 */
export function useSessionBootstrap() {
  const setSession = useAuthStore((s) => s.setSession);
  const setSessionError = useAuthStore((s) => s.setSessionError);

  const query = useSessionQuery();

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setSession(query.data);
    }
  }, [query.isSuccess, query.data, setSession]);

  useEffect(() => {
    if (query.isError) {
      setSessionError();
    }
  }, [query.isError, setSessionError]);
}
